// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","lock":"RingLock_lock__IAoba","ring":"RingLock_ring__RTq6y"};